import { colors } from '@material-ui/core';

const MuiTableHead = {
  root: {
    backgroundColor: colors.grey[50]
  }
};

export default MuiTableHead;
